import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

export const getProducts = createAsyncThunk(
  "productsSlice/getProducts",
  async (data) => {
    return await fetch("https://api.mobrespos.com/get_image", {
      method: "POST",
      body: JSON.stringify(data),
      headers: {
        Accept: "application/json",
      },
    })
      .then((res) => {
        return res.json();
      })
      .then((datax) => {
        const newArr = datax.map((v, index) => ({ ...v, id: index }));
        return newArr;
      })
      .catch((error) => {
        console.log(error);
      });
  }
);

const initialState = {
  status: null,
  data: [],
};

const productsSlice = createSlice({
  name: "productsSlice",
  initialState,
  extraReducers: {
    [getProducts.pending]: (state) => {
      state.status = true;
    },

    [getProducts.fulfilled]: (state, action) => {
      state.status = false;
      state.data = action.payload;
    },

    [getProducts.rejected]: (state) => {
      state.status = false;
    },
  },
});

export default productsSlice.reducer;
